import React, { PureComponent } from 'react';
// import DatePicker from 'react-datepicker';
import { Button, Checkbox, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import WarningPopup from './WarningPopup';
import { REVISION, DATE_CHANGE, EMPTY_WEEKS } from '../../../Constants/constants';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { WithStyles, withStyles } from '@material-ui/core';
import {
  moveSyllabus,
  // deletePhase,
  // addEmptyWeeks,
  updatePhaseDetails,
  getNearestSunday,
  getWeekAfterStartDate,
  updateDates,
  getMaxDateForStart,
  getMinDateForEnd,
  weeksCount,
  findMaxChapterCount,
} from '../helper';
import MyPATCalendar from '../../../../common/MyPATCalendar';
import MyPATTextField from '../../../../common/MyPATTextField';
import { editMilestoneStyle } from '../../../styles';
import { showMsg } from '../../../../user-management/actions/miniLibrariesActions';
import { dateService, MyPATSelect } from '../../../../common';

interface EditMileStoneProps extends WithStyles<typeof editMilestoneStyle> {
  editMiles: boolean;
  confirmationFor: string;
  parent: any;
  close: Function;
  treeData: any;
  setTreeData: Function;
  wasRevision?: boolean;
  classes: any;
  isConflict?: boolean;
  showMsg: any;
}

interface EditMileStoneState {
  isSave: boolean;
  isRevision: boolean;
  name: string;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  error: boolean;
  errorText: string;
  durationError: string;
  needConfirmation: boolean;
}

class EditMileStone extends PureComponent<EditMileStoneProps, EditMileStoneState> {
  constructor(props: EditMileStoneProps) {
    super(props);
    this.state = {
      isSave: false,
      isRevision: this.props.parent.isRevision,
      name: this.props.parent.name,
      startDate: new Date(this.props.parent.startDate),
      endDate: new Date(this.props.parent.endDate),
      minDate: this.props.editMiles ? this.getMinDate() : new Date(this.props.parent.startDate),
      maxDate: this.props.editMiles ? this.getMaxDate() : new Date(this.props.parent.endDate),
      error: false,
      errorText: '',
      durationError: '',
      needConfirmation: false,
    };
  }

  getMinDate = () => {
    const { parent, treeData } = this.props;
    if (parent.phaseIndex === 0) {
      return new Date(treeData.startDate);
    } else {
      const prevPhaseIndex = parent.phaseIndex - 1;
      let minDate = new Date(treeData.phases[prevPhaseIndex].endDate);
      minDate.setDate(minDate.getDate() + 1);
      return new Date(minDate);
    }
  };

  getMaxDate = () => {
    const { parent, treeData } = this.props;
    if (parent.phaseIndex === treeData.phases.length - 1) {
      return new Date(treeData.endDate);
    } else {
      const nextPhaseIndex = parent.phaseIndex + 1;
      let maxDate = new Date(treeData.phases[nextPhaseIndex].startDate);
      maxDate.setDate(maxDate.getDate() - 1);
      return new Date(maxDate);
    }
  };

  getMaxDateForWeek = () => {
    const { parent } = this.props;
    new Date(parent.endDate);
  };

  handleSaveButton = () => {
    const {
      editMiles,
      close,
      wasRevision,
      treeData,
      setTreeData,
      parent: { phaseIndex },
    } = this.props;
    const newDetails = {
      name: this.state.name,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      isRevision: this.state.isRevision,
    };
    this.setState({ isSave: true });
    if (editMiles && !wasRevision && !this.state.isRevision) {
      //if phase not marked as revision
      const newWeeksCount = weeksCount(newDetails.startDate, newDetails.endDate, treeData.weekFormat);
      const maxChapterCount = findMaxChapterCount(this.props.parent);
      if (newWeeksCount > maxChapterCount) {
        this.setState({ needConfirmation: true });
      }
      else{updatePhaseDetails(treeData, setTreeData, phaseIndex, newDetails);
      close();}
    }
    if (editMiles && wasRevision && !this.state.isRevision) {
      //if phase was unmarked as revision
      const newWeeksCount = weeksCount(newDetails.startDate, newDetails.endDate, treeData.weekFormat);
      const maxChapterCount = findMaxChapterCount(this.props.parent);
      if (newWeeksCount > maxChapterCount) {
        this.setState({ needConfirmation: true });
      }
      else{updatePhaseDetails(treeData, setTreeData, phaseIndex, newDetails);
      close();}
    }
    if (editMiles && wasRevision && this.state.isRevision) {
      //if phase remains marked as revision
      updatePhaseDetails(treeData, setTreeData, phaseIndex, newDetails);
      close();
    }
  };

 
  handleIsRevision = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const isLastPhase = this.props.parent.phaseIndex + 1 >= this.props.treeData.totalPhases;
      if (isLastPhase) {
        this.props.showMsg('Last phase cannot be marked as revision', 'error');
      } else {
        this.setState((prevState) => ({ ...prevState, isRevision: true }));
      }
    } else {
      this.setState((prevState) => ({ ...prevState, isRevision: false }));
    }
  };

  handleConfirmation = (confirmed: boolean) => {
    const {
      editMiles,
      treeData,
      setTreeData,
      parent: { phaseIndex, children },
    } = this.props;
    const newDetails = {
      name: this.state.name,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };

    if (editMiles && confirmed && children.length) {
      // if phase is marked as revision
      moveSyllabus(treeData, setTreeData, phaseIndex, newDetails);
    }

    if (!editMiles && confirmed) {
      //if week date format was changed change format of entire course plan
      updateDates(treeData, setTreeData, phaseIndex, this.state.endDate, this.props.parent);
    }
    this.props.close();
  };

  handlePopUPResponse = (confirmed: boolean) => {
    if (confirmed) {
      const {
        treeData,
      setTreeData,
      parent: { phaseIndex },
    } = this.props;
    const newDetails = {
      name: this.state.name,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      isRevision: this.state.isRevision,
    };
    updatePhaseDetails(treeData, setTreeData, phaseIndex, newDetails);
  }
    this.props.close();
  }

  handleNameChange = (name: string) => {
    if (name) {
      this.setState((prevState: EditMileStoneState) => ({ ...prevState, name: name, error: false, errorText: '' }));
    } else {
      this.setState((prevState: EditMileStoneState) => ({
        ...prevState,
        name: '',
        error: true,
        errorText: 'Name is required',
      }));
    }
  };

  isStartDateInvalid = (date: Date | string) => {
    const currentStart = new Date(date).getTime();
    const currentEnd = new Date(this.state.endDate).getTime();
    const { treeData, parent } = this.props;
    if (parent.key === 'phase') {
      if(parent.phaseIndex !== 0)
      {
        const prevPhase = treeData.phases[parent.phaseIndex - 1]
        const prevPhaseEnd = new Date(prevPhase.endDate).getTime();
        return currentStart > currentEnd || currentStart <= prevPhaseEnd
      }
      else {
        const courseStart = new Date(treeData.startDate).getTime();
        const courseEnd = new Date(treeData.endDate).getTime();
        return currentStart > currentEnd || currentStart < courseStart|| currentStart > courseEnd
      }
    }
    if (parent.key === 'week') {
      
      if(parent.weekIndex !== 0)
      {
        const prevWeek = treeData.phases[parent.phaseIndex].weeks[parent.weekIndex-1]
        const prevWeekEnd = new Date(prevWeek.endDate).getTime();
        return currentStart > currentEnd || currentStart <= prevWeekEnd
      }
      else {
        const currentPhase= treeData.phases[parent.phaseIndex]
        const currentPhaseStart = new Date(currentPhase.startDate).getTime();
        return currentStart > currentEnd || currentStart < currentPhaseStart
      }
    }
  }

  isEndDateInvalid = (date: Date | string) => {
    const currentStart = new Date(this.state.startDate).getTime();
    const currentEnd = new Date(date).getTime();
    const { treeData, parent } = this.props;
    if (parent.key === 'phase') {
      if(parent.phaseIndex !== treeData.phases.length -1)
      {
        const nextPhase = treeData.phases[parent.phaseIndex + 1]
        const nextPhaseStart = new Date(nextPhase.startDate).getTime();
        return currentStart > currentEnd || currentEnd >= nextPhaseStart
      }
      else {
        const courseStart = new Date(treeData.startDate).getTime();
        const courseEnd = new Date(treeData.endDate).getTime();
        return currentStart > currentEnd || currentEnd < courseStart|| currentEnd > courseEnd
      }
    }
    if (parent.key === 'week') {
      const currentPhase = treeData.phases[parent.phaseIndex]
      if(parent.weekIndex !== currentPhase.weeks.length-1)
      {
        // const nextWeek = treeData.phases[parent.phaseIndex].weeks[parent.weekIndex+1]
        // const nextWeekStart = new Date(nextWeek.startDate).getTime();
        return currentStart > currentEnd; 
        // || currentEnd >= nextWeekStart
      }
      else {
        const currentPhaseEnd = new Date(currentPhase.endDate).getTime();
        return currentStart > currentEnd || currentEnd > currentPhaseEnd
      }
    }
  }
  
  handleStartDateChange = (date: any) => {
    if (this.isStartDateInvalid(date)) {
      this.setState({ startDate: date, durationError: 'Invalid duration' });
    } else {
      this.setState({ startDate: date, durationError: '' });
    }
  };

  handleEndDateChange = (date: any) => {
    if (this.isEndDateInvalid(date)) {
      this.setState({ endDate: date, durationError: 'Invalid duration' });
    } else {
      this.setState({ endDate: date, durationError: '' });
    }
  };

  handleSelectedEndDateChange = (event: any) => {
    const date = (event.target.value);
    
    if (this.isEndDateInvalid(date)) {
      this.setState({ endDate: new Date(date), durationError: 'Invalid duration' });
    } else {
      this.setState({ endDate: new Date(date), durationError: '' });
    }
  }

  getMinEndDateForWeek = (date: Date | string) => {
    const { treeData, parent } = this.props;
    const { phases } = treeData;
    const currentPhase = phases[parent.phaseIndex];
    const minDate = new Date(getNearestSunday(date));

    if (new Date(currentPhase.endDate).getTime() < minDate.getTime()) {
      return this.state.endDate;
    }
    return minDate;
  };

  getMaxEndDateForWeek = (date: Date | string) => {
    const { treeData, parent } = this.props;
    const { phases } = treeData;
    const currentPhase = phases[parent.phaseIndex];
    const maxDate = new Date(getWeekAfterStartDate(date));

    if (new Date(currentPhase.endDate).getTime() < maxDate.getTime()) {
      return this.state.endDate;
    }
    return maxDate;
  };

  renderEndDateOptions = (minDate: Date | string, maxDate: Date | string) => {
    let options = [];
    
    // One date with +7 and one of upcoming Sunday 
    
    if(minDate.toString() === maxDate.toString()) {
      options.push(<option key={0} value={minDate.toString()} >{dateService.dateFromString(minDate.toString())}</option>)
    } else {
      options.push(<option key={0} value={minDate.toString()} >{dateService.dateFromString(minDate.toString())}</option>)
      options.push(<option key={1} value={maxDate.toString()} >{dateService.dateFromString(maxDate.toString())}</option>)
    }
    return options;
  }

  render() {
    const { editMiles, close, classes, wasRevision, parent } = this.props;
    const { isSave, isRevision, name, startDate, endDate, minDate, maxDate, durationError,needConfirmation } = this.state;
    this.handleStartDateChange(this.state.startDate);
    this.handleEndDateChange(this.state.endDate);
    const minDateOption = editMiles ? getMinDateForEnd(startDate) : this.getMinEndDateForWeek(startDate);
    const maxDateOption = editMiles ? maxDate : this.getMaxEndDateForWeek(startDate);
    
    

    return (
      <>
        <div style={{ 
          backgroundColor: this.props.isConflict ? '#FFF4F4' : 'white',
          }}>
          <Grid container justify='space-between' alignItems='center' spacing={8} className={classes.addEditMilestone}>
            <Grid item>
              <Grid container justify='flex-start' spacing={8}>
                <Grid item>
                  <MyPATTextField
                    fullWidthControl
                    disabled={!editMiles}
                    id='outlined-uncontrolled'
                    fullWidth
                    name='name'
                    margin='normal'
                    variant='outlined'
                    value={name}
                    onChange={(e: any) => {
                      this.handleNameChange(e.target.value);
                    }}
                    error={this.state.error}
                    errorText={this.state.errorText}
                  />
                </Grid>
                <Grid item>
                  <MyPATCalendar
                    disabled={!editMiles}
                    minDate={minDate}
                    maxDate={new Date(maxDate).setDate(new Date(maxDate).getDate()-1)}
                    date={startDate}
                    onChange={(date: Date) => this.handleStartDateChange(date)}
                    errorText={durationError}
                  />
                </Grid>
               { parent.key === 'week' ? (
                 <Grid item>
                    <MyPATSelect
                      value={endDate}
                      name='endDate'
                      onChange={(e: any) => this.handleSelectedEndDateChange(e)}
                      inputClass={classes.selectOrgStyle}
                    >
                      {
                        this.renderEndDateOptions(minDateOption, maxDateOption)
                      }
                    </MyPATSelect>
                 </Grid>
               ) :
               (<Grid item>
                  <MyPATCalendar
                    minDate={editMiles ? getMinDateForEnd(startDate) : this.getMinEndDateForWeek(startDate)}
                    maxDate={editMiles ? maxDate : this.getMaxEndDateForWeek(startDate)}
                    date={endDate}
                    onChange={(date: Date) => this.handleEndDateChange(date)}
                    errorText={durationError}
                  />
                </Grid>)}
                {editMiles && (
                  <Grid item>
                    <Checkbox
                      onChange={(event) => this.handleIsRevision(event)}
                      value='Is Revision'
                      color='primary'
                      checked={this.state.isRevision}
                    />
                    Is Revision?
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item>
              <Button
                style={{ marginRight: '8px' }}
                variant='outlined'
                size='small'
                color='primary'
                onClick={(event) => close()}
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.error || Boolean(durationError)}
                onClick={this.handleSaveButton}
                variant='contained'
                size='small'
                color='primary'
              >
                Save
              </Button>
              {isSave && parent.children && parent.children.length && isRevision && !wasRevision ? (
                <WarningPopup confirmationFor={REVISION} handleResponse={this.handleConfirmation} />
              ) : (
                <></>
              )}
               {isSave && editMiles && needConfirmation ? (
                <WarningPopup confirmationFor={EMPTY_WEEKS} handleResponse={this.handlePopUPResponse} />
              ) : (
                <></>
              )}
              {isSave && !editMiles ? (
                <WarningPopup confirmationFor={DATE_CHANGE} handleResponse={this.handleConfirmation} />
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
      showMsg: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(editMilestoneStyle)(EditMileStone));

